
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/[resource_id]/book",
      function () {
        return require("private-next-pages/[publicId]/[resource_id]/book/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]/[resource_id]/book"])
      });
    }
  